import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import users from "../../apiConfigs/users";
import { ReactComponent as Seperate } from "../../assets/seperator.svg";
import Button from "../../designComponents/Button";
import Dropdown from "../../designComponents/Dropdown/Dropdown";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import Typography from "../../designComponents/Typography";
import requestAPI from "../../utils/requestAPI";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  ActiveNavText,
  Navigation,
  NavLink,
  NavText,
  Title,
  Wrapper,
} from "../Properties/Details/styles";

const AddUser = () => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const navigate = useNavigate();

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    const file = e.dataTransfer.files[0];
    setUploadedFile(file);
  };
  const [selectedRoles, setSelectedRoles] = useState<string>("LANDLORD");
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    address: Yup.string().required("Address is required"),
  });
  const roleOptions = [
    { label: "Landlord", value: "LANDLORD" },
    { label: "Service Provider", value: "SERVICE_PROVIDER" },
  ];
  const handleSubmit = async (values: {
    firstName: string;
    lastName: string;
    address: string;
    email: string;
    phoneNumber: string;
    accountStatus: string;
    role: string;
    avatar: File | null;
  }) => {
    let providedUrl = "";

    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys( { category: "avatar", fileUri: [uploadedFile], userId: 'new' });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
      }

      await requestAPI(
        users.createUser({
          firstName: values.firstName,
          lastName: values.lastName,
          address: values.address,
          email: values.email,
          phone: values.phoneNumber,
          roles: [selectedRoles],
          avatar: providedUrl,
        })
      );
      toast.success("Successfylly Added user");
      navigate(-1);
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  return (
    <Wrapper>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Title style={{ paddingBottom: 14 }}>Add User</Title>
          <Navigation
            style={{
              paddingBottom: 15,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <NavLink onClick={() => navigate(-1)}>
              <NavText>Table</NavText>
            </NavLink>
            <Seperate fill="#7E7E7E"></Seperate>
            <ActiveNavText>Add User</ActiveNavText>
          </Navigation>
        </div>
        <div
          style={{
            display: "flex",
            gap: 20,
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{
              border: "1px solid #D8D8D8",
              background: "white",
              borderRadius: 8,
              color: "#7E7E7E",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>

      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          address: "",
          userRole: "",
          accountStatus: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          //@ts-ignore
          handleSubmit(values);
        }}
      >
        {({ setFieldValue }) => (
          <Form style={{ width: "100%", gap: 20 }}>
            <div style={{ display: "flex", gap: 18 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 18,
                  flex: 1,
                }}
              >
                <div
                  className="add-user-card"
                  style={{
                    backgroundColor: "white",
                    padding: 16,
                    borderRadius: 10,
                    border: "1px solid #F1EFFB",
                  }}
                >
                  <Typography fontWeight="medium" size={"h3"}>
                    General Information
                  </Typography>

                  <div
                    style={{
                      display: "flex",
                      gap: 20, // Add space between the fields
                      width: "100%",
                    }}
                  >
                    {/* First Name Input Field and Error Message */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column", // Stack label, input, and error vertically
                        gap: 6,
                        width: "50%", // Control width of each input field
                      }}
                    >
                      <LabelInputField
                        onChange={(e) => {
                          setFieldValue("firstName", e.target.value);
                        }}
                        name="firstName"
                        placeHolder="Type full name eg. Alfonso Crist"
                        style={{
                          label: {
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#555A77",
                          },
                          input: {
                            height: 50,
                            border: "1px solid #F1EFFB",
                            padding: 8,
                            background: "#F1EFFB",
                            borderRadius: 6,
                            width: "100%",
                          },
                          container: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            paddingTop: 14,
                            width: "100%", // Ensure input takes full width inside its container
                          },
                        }}
                        label="First Name"
                      />
                      <div style={{ paddingTop: 10 }}>
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          //@ts-ignore
                          style={{ color: "red" }}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column", // Stack label, input, and error vertically
                        gap: 6,
                        width: "50%", // Control width of each input field
                      }}
                    >
                      <LabelInputField
                        onChange={(e) => {
                          setFieldValue("lastName", e.target.value);
                        }}
                        name="lastName"
                        placeHolder="Type full name eg. Alfonso Crist"
                        style={{
                          label: {
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#555A77",
                          },
                          input: {
                            height: 50,
                            border: "1px solid #F1EFFB",
                            padding: 8,
                            background: "#F1EFFB",
                            borderRadius: 6,
                            width: "100%",
                          },
                          container: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            paddingTop: 14,
                            width: "100%", // Ensure input takes full width inside its container
                          },
                        }}
                        label="Last Name"
                      />
                      <div style={{ paddingTop: 10 }}>
                        <ErrorMessage
                          name="lastName"
                          component="div"
                          //@ts-ignore

                          style={{ color: "red" }}
                        />
                      </div>
                    </div>
                  </div>

                  <LabelInputField
                    name="email"
                    onChange={(e) => {
                      setFieldValue("email", e.target.value);
                    }}
                    placeHolder="Type valid email eg. Alfonso.Crist09@gmail.com"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                    label="Email"
                  />
                  <div style={{ paddingTop: 10 }}>
                    <ErrorMessage
                      name="email"
                      component="div"
                      //@ts-ignore

                      style={{ color: "red" }}
                    />
                  </div>
                </div>

                <div
                  className="add-user-card"
                  style={{
                    backgroundColor: "white",
                    padding: 16,
                    borderRadius: 10,
                    border: "1px solid #F1EFFB",
                  }}
                >
                  <Typography fontWeight="medium" size={"h3"}>
                    Personal Information
                  </Typography>

                  <LabelInputField
                    name="phoneNumber"
                    onChange={(e) => {
                      setFieldValue("phoneNumber", e.target.value);
                    }}
                    placeHolder="Type Phone Number eg. (933) 999999999"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                    label="Phone Number"
                  />
                  <div style={{ paddingTop: 10 }}>
                    <ErrorMessage
                      name="phoneNumber"
                      component="div"
                      //@ts-ignore

                      style={{ color: "red" }}
                    />
                  </div>
                  <LabelInputField
                    name="address"
                    onChange={(e) => {
                      setFieldValue("address", e.target.value);
                    }}
                    placeHolder="Type valid Address eg. Dublin 2, Temple Bar, County Dublin"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                    label="Address"
                  />
                  <div style={{ paddingTop: 10 }}>
                    <ErrorMessage
                      name="address"
                      component="div"
                      //@ts-ignore

                      style={{ color: "red" }}
                    />
                  </div>
                  <MediaUploader
                    label="Profile Picture"
                    setSelectedFiles={setUploadedFile}
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setUploadedFile(file);
                    }}
                    style={{
                      container: { paddingTop: 10, gap: 6 },
                      label: { paddingBottom: 10, color: "#555A77" },
                      dropzone: { background: "#F1EFFB" },
                    }}
                  ></MediaUploader>
                </div>
              </div>

              <div
                style={{ display: "flex", flexDirection: "column", gap: 26 }}
              >
                <div
                  style={{
                    width: 400,
                    height: 160,
                    background: "white",
                    borderRadius: 6,
                    padding: 10,
                    border: "1px solid #F1EFFB",
                  }}
                >
                  <Typography fontWeight="medium" size={"h3"}>
                    User Role
                  </Typography>
                  <Dropdown
                    options={roleOptions}
                    label="Select admin Role"
                    style={{
                      container: { paddingTop: 10 },
                      label: { paddingBottom: 6, color: "#555A77" },
                      select: {
                        backgroundColor: "#F1EFFB",
                        fontSize: 14,
                        fontFamily: "urbanist",
                        fontWeight: 500,
                        padding: "8px",
                      },
                    }}
                    onChange={(e) => {
                      setSelectedRoles(e.target.value);
                    }}
                  ></Dropdown>

                  <div style={{ paddingTop: 10 }}>
                    <ErrorMessage
                      name="userRole"
                      component="div"
                      //@ts-ignore

                      style={{ color: "red" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ paddingTop: 20 }}>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#725ED4",
                  borderRadius: 8,
                  color: "white",
                }}
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Wrapper>
  );
};

export default AddUser;
